const BlazeError = require('./blaze');
const { AUTHENTICATION_ERROR_STATUS } = require('../constants');

class BlazeAuthenticationError extends BlazeError {
  constructor(...args) {
    super(...args);
    this.status = AUTHENTICATION_ERROR_STATUS;
  }
}

module.exports = BlazeAuthenticationError;
